<div class="space-y-2">
  <div class="course-image rounded-lg shadow-md overflow-hidden duration-300">
    <span
      class="absolute top-2 right-2 badge bg-blue-500 text-white px-2 py-1 rounded text-xs font-bold uppercase z-10"
      >Series
    </span>
    <div class="aspect-w-16 aspect-h-9">
      <img
        [src]="series?.thumb_path || 'assets/images/no-image.jpg'"
        [alt]="series?.title || 'No image available'"
        class="w-full h-full object-cover rounded-lg duration-300"
        loading="lazy"
      />
    </div>
  </div>

  <div class="space-y-1">
    <p class="text-xs text-gray-600 text-center">
      <span class="font-bold">
        {{ series?.courseCount ?? 0 }}
        {{ (series?.courseCount ?? 0) > 1 ? 'COURSES' : 'COURSE' }}</span
      >
    </p>
  </div>
</div>
